import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/PaperPlaneRight.es.js";
const a = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...o, weights: n }));
a.displayName = "PaperPlaneRightIcon";
const p = a;
export {
  p as PaperPlaneRight,
  a as PaperPlaneRightIcon
};
